import React from 'react';
import {Modal, Text, View, TouchableOpacity, Image} from 'react-native';
import {createStyles} from '../../utils/createStyles';
import LinearGradient from 'react-native-linear-gradient';

interface UpgradeModalProps {
  visible: boolean;
  type: 'stage' | 'grade' | 'term' | 'test';
  nextGrade?: number;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
}

const UpgradeModal: React.FC<UpgradeModalProps> = ({
  visible,
  type,
  nextGrade,
  onConfirm,
  onCancel,
  confirmText,
  cancelText,
}) => {
  console.log('Modal渲染:', {visible, type});

  const isHighLevel = type === 'grade' || type === 'stage';

  const getMessage = () => {
    switch (type) {
      case 'stage':
        return (
          <>
            <Text style={styles.message}>系统检测到您已完成初中阶段学习</Text>
            <Text style={styles.message}>是否为您更新学段，更新后为高中？</Text>
            <Text style={styles.tipMessage}>
              *说明：后续也可在 个人中心 - 学生信息 修改
            </Text>
          </>
        );
      case 'grade':
        return (
          <>
            <Text style={styles.message}>系统检测到已经是新的学年</Text>
            <Text style={styles.message}>
              是否为您更新年级，更新年级后为{nextGrade}年级？
            </Text>
            <Text style={styles.tipMessage}>
              *说明：后续也可在 个人中心 - 学生信息 修改
            </Text>
          </>
        );
      case 'term':
        return (
          <>
            <Text style={styles.message}>系统检测到已经是新的学期</Text>
            <Text style={styles.message}>是否为您更新学期？</Text>
          </>
        );
      case 'test': {
        return (
          <>
            <Text style={styles.message}>您的年级或学期信息已发生变更</Text>
            <Text style={styles.message}>是否重新生成测评？</Text>
          </>
        );
      }
    }
  };

  return (
    <Modal visible={visible} transparent animationType="fade">
      <View style={styles.container}>
        <View
          style={[
            styles.content,
            isHighLevel ? styles.gradeContent : styles.termContent,
          ]}>
          <View style={styles.header}>
            <Image
              source={{
                uri: 'https://zijinshe-media.oss-cn-beijing.aliyuncs.com/webapp/classroom/newPad/gradeModalTips.png',
              }}
              style={styles.headerImage}
            />
          </View>
          <View style={styles.messageContainer}>{getMessage()}</View>
          <View
            style={[
              styles.buttonContainer,
              isHighLevel ? styles.gradeButtons : styles.termButtons,
            ]}>
            <TouchableOpacity
              style={[
                styles.button,
                isHighLevel
                  ? styles.gradeCancelButton
                  : styles.termCancelButton,
              ]}
              onPress={onCancel}>
              <Text style={[styles.buttonText]}>
                {cancelText ? cancelText : isHighLevel ? '暂不升级' : '取消'}
              </Text>
            </TouchableOpacity>
            <TouchableOpacity style={[styles.button]} onPress={onConfirm}>
              <LinearGradient
                colors={['#887DFF', '#695DF3']}
                start={{x: 0, y: 0}}
                end={{x: 0, y: 1}}
                style={[styles.gradientButton]}>
                <Text style={styles.confirmText}>
                  {confirmText
                    ? confirmText
                    : isHighLevel
                    ? '确定升级'
                    : '确定'}
                </Text>
              </LinearGradient>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = createStyles({
  container: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    backgroundColor: 'white',
    borderRadius: 12,
    padding: 20,
    width: '33.6rem',
    position: 'relative',
  },
  gradeContent: {
    height: '22.1rem',
  },
  termContent: {
    height: '19rem',
  },
  header: {
    alignItems: 'center',
    marginTop: '-4rem',
    width: '100%',
    position: 'relative',
  },
  headerImage: {
    width: '6.05rem',
    height: '6.05rem',
  },
  messageContainer: {
    marginTop: '1rem',
    marginBottom: 24,
  },
  message: {
    fontSize: 16,
    textAlign: 'center',
    color: '#333',
    lineHeight: 24,
    marginBottom: 8,
  },
  tipMessage: {
    fontSize: 12,
    color: '#999',
    textAlign: 'center',
    marginTop: 12,
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: 'auto',
    paddingTop: '1rem',
  },
  gradeButtons: {
    marginHorizontal: -8,
  },
  termButtons: {
    marginHorizontal: -4,
  },
  button: {
    flex: 1,
    marginHorizontal: '0.8rem',
    width: '13.3rem',
  },
  gradientButton: {
    height: '3.8rem',
    borderRadius: '2.9rem',
    alignItems: 'center',
    justifyContent: 'center',
  },
  gradeCancelButton: {
    backgroundColor: 'white',
    borderWidth: 1,
    borderColor: '#9E99FF',
    height: '3.8rem',
    borderRadius: '2.9rem',
    alignItems: 'center',
    justifyContent: 'center',
  },
  termCancelButton: {
    backgroundColor: 'white',
    borderWidth: 1,
    borderColor: '#9E99FF',
    height: '3.8rem',
    borderRadius: '2.9rem',
    alignItems: 'center',
    justifyContent: 'center',
  },
  confirmText: {
    color: 'white',
    fontSize: '1.3rem',
  },
  buttonText: {
    fontSize: '1.3rem',
    color: '#9E99FF',
  },
});

export default UpgradeModal;
